import { ACTIONS } from 'actions/appreciation'
import { A } from 'aws-amplify-react/lib-esm/AmplifyTheme'

export const initialState = {
    appState: {
        employeesLoaded: false,
        employeesLoading: false,
        employeesError: null,
        appreciationListLoaded: false,
        appreciationListLoading: false,
        appreciationListError: null,
        addAppreciationListLoaded: false,
        addAppreciationListLoading: false,
        addAppreciationListError: null,
    },
    database: {
        appreciationList: [],
        employees: [],
    },
}

export default (state = initialState, action) => {
    const { database, appState } = state

    switch (action.type) {
        case ACTIONS.GET_EMPLOYEE.START:
            return {
                ...state,
                appState: { ...appState, employeesLoading: true },
            }
        case ACTIONS.GET_EMPLOYEE.SUCCESS:
            return {
                ...state,
                appState: { ...appState, employeesLoaded: true, employeesLoading: false, employeesError: null },
                database: { ...database, employees: [...action.data] },
            }
        case ACTIONS.GET_EMPLOYEE.FAILURE:
            return {
                ...state,
                appState: { ...appState, employeesLoaded: false, employeesLoading: false, employeesError: action.error },
            }
        case ACTIONS.POST_APPRECIATION.START:
            return {
                ...state,
                appState: { ...appState, addAppreciationListLoading: true },
            }
        case ACTIONS.POST_APPRECIATION.SUCCESS:
            return {
                ...state,
                appState: { ...appState, addAppreciationListLoaded: true, addAppreciationListLoading: false, addAppreciationListError: null },
            }
        case ACTIONS.POST_APPRECIATION.FAILURE:
            return {
                ...state,
                appState: {
                    ...appState,
                    addAppreciationListLoaded: false,
                    addAppreciationListLoading: false,
                    addAppreciationListError: action.error,
                },
            }
        case ACTIONS.GET_APPRECIATIONS.START:
            return {
                ...state,
                appState: { ...appState, appreciationListLoadedLoading: true },
            }
        case ACTIONS.GET_APPRECIATIONS.SUCCESS:
            return {
                ...state,
                appState: {
                    ...appState,
                    appreciationListLoadedLoaded: true,
                    appreciationListLoadedLoading: false,
                    appreciationListLoadedError: null,
                },
                database: { ...database, appreciationList: [...action.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))] },
            }
        case ACTIONS.GET_APPRECIATIONS.FAILURE:
            return {
                ...state,
                appState: {
                    ...appState,
                    appreciationListLoadedLoaded: false,
                    appreciationListLoadedLoading: false,
                    appreciationListLoadedError: action.error,
                },
            }
        default:
            return state
    }
}
